export default "__VITE_ASSET__BEdDMQRt__"